import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class } from '../utils';
import QueryResult from '../QueryResult';
import DetailsHandlerDef from './DetailsHandlerDef';
import { getWKTParser } from "../util/getWKTParser";
export default Class(DetailsHandlerDef, {
  limit: null,
  imageUri: null,
  buttonText: null,
  initialize: function initialize(options) {
    this.limit = 3;
    this.headerListItem = null;
    this.footerListItem = null;
    this.noResultsListItem = null;
    this.distanceFilter = 'all'; //'all', 'zero', 'nonzero'

    this.proxySearcher = null;
    this.allResultsProcessors = [];
    this.wktParser = getWKTParser();
    this._searchers = [];
    var DetailsHandlerDefOptions;

    if (typeof options !== 'undefined') {
      DetailsHandlerDefOptions = options;
      if (options.limit) this.limit = options.limit;
      if (options.headerListItem) this.headerListItem = options.headerListItem;
      if (options.footerListItem) this.footerListItem = options.footerListItem;
      if (options.noResultsListItem) this.noResultsListItem = options.noResultsListItem;
      if (options.distanceFilter) this.distanceFilter = options.distanceFilter;
      if (options.proxySearcher) this.proxySearcher = options.proxySearcher;
      if (options.searchers) this.searchers = options.searchers;
    } else {
      DetailsHandlerDefOptions = {};
    }

    if (typeof DetailsHandlerDefOptions.isApplicable === 'undefined') DetailsHandlerDefOptions.isApplicable = function (result) {
      return result.geometry !== null;
    };
    DetailsHandlerDefOptions.handler = this.handler;
    DetailsHandlerDef.prototype.initialize.apply(this, [DetailsHandlerDefOptions]);
  },

  set searchers(sCollection) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = sCollection[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var searcher = _step.value;
        this.addSearcher(searcher);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },

  get searchers() {
    return this._searchers;
  },

  addSearcher: function addSearcher(searcher) {
    this._searchers.push(searcher);
  },
  geometryPreProcessor: function () {
    var _geometryPreProcessor = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(result) {
      var distGeometry, queryGeometry, resultWKT, sqResult, results;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.isApplicable(result)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", null);

            case 2:
              distGeometry = null;
              queryGeometry = null;
              if (this.distanceFilter !== 'zero') distGeometry = result.geometry;else queryGeometry = result.geometry;

              if (!this.proxySearcher) {
                _context.next = 16;
                break;
              }

              resultWKT = result.searcher.translateGeoJsonObjectToWkt(result.geometry);
              _context.next = 9;
              return this.proxySearcher.sq({
                limit: 1,
                wkt: resultWKT
              });

            case 9:
              sqResult = _context.sent;
              results = sqResult.getAllResults();

              if (!(results.length > 0)) {
                _context.next = 15;
                break;
              }

              queryGeometry = results[0].geometry;
              _context.next = 16;
              break;

            case 15:
              return _context.abrupt("return", null);

            case 16:
              return _context.abrupt("return", {
                queryGeometry: queryGeometry,
                distGeometry: distGeometry
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function geometryPreProcessor(_x) {
      return _geometryPreProcessor.apply(this, arguments);
    }

    return geometryPreProcessor;
  }(),
  handler: function () {
    var _handler = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(result) {
      var geometryInfo, items;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.geometryPreProcessor(result);

            case 2:
              geometryInfo = _context2.sent;

              if (!(geometryInfo !== null)) {
                _context2.next = 10;
                break;
              }

              _context2.next = 6;
              return this.doSq(result, geometryInfo);

            case 6:
              items = _context2.sent;
              return _context2.abrupt("return", items);

            case 10:
              return _context2.abrupt("return", [this.noResultsListItem]);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function handler(_x2) {
      return _handler.apply(this, arguments);
    }

    return handler;
  }(),
  doSq: function () {
    var _doSq = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(result, geometryInfo) {
      var query, promises, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, searcher, searcherResults, queryResult, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, searcherResult, processResult, types, allResults, sqInfo, items;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              query = {
                limit: this.limit,
                title: result.title
              };
              if (geometryInfo.queryGeometry && geometryInfo.queryGeometry !== null) query.wkt = this.wktParser.convert(geometryInfo.queryGeometry);
              if (geometryInfo.distGeometry && geometryInfo.distGeometry !== null) query.distWkt = this.wktParser.convert(geometryInfo.distGeometry);
              promises = [];
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context3.prev = 7;

              for (_iterator2 = this.searchers[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                searcher = _step2.value;
                promises.push(searcher.sq(query));
              }

              _context3.next = 15;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](7);
              _didIteratorError2 = true;
              _iteratorError2 = _context3.t0;

            case 15:
              _context3.prev = 15;
              _context3.prev = 16;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 18:
              _context3.prev = 18;

              if (!_didIteratorError2) {
                _context3.next = 21;
                break;
              }

              throw _iteratorError2;

            case 21:
              return _context3.finish(18);

            case 22:
              return _context3.finish(15);

            case 23:
              _context3.next = 25;
              return Promise.all(promises);

            case 25:
              searcherResults = _context3.sent;
              queryResult = new QueryResult(null);
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context3.prev = 30;

              for (_iterator3 = searcherResults[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                searcherResult = _step3.value;
                queryResult.addResults(searcherResult.getResults());
              }

              _context3.next = 38;
              break;

            case 34:
              _context3.prev = 34;
              _context3.t1 = _context3["catch"](30);
              _didIteratorError3 = true;
              _iteratorError3 = _context3.t1;

            case 38:
              _context3.prev = 38;
              _context3.prev = 39;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 41:
              _context3.prev = 41;

              if (!_didIteratorError3) {
                _context3.next = 44;
                break;
              }

              throw _iteratorError3;

            case 44:
              return _context3.finish(41);

            case 45:
              return _context3.finish(38);

            case 46:
              processResult = this.groupAndFilterResults(queryResult);
              types = processResult.types;
              allResults = processResult.allResults;
              sqInfo = {
                mainResult: result,
                hitResults: allResults
              };
              _context3.next = 52;
              return this.procesAllResults(sqInfo);

            case 52:
              items = this.buildOutput(types, sqInfo);
              return _context3.abrupt("return", items);

            case 54:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[7, 11, 15, 23], [16,, 18, 22], [30, 34, 38, 46], [39,, 41, 45]]);
    }));

    function doSq(_x3, _x4) {
      return _doSq.apply(this, arguments);
    }

    return doSq;
  }(),
  procesAllResults: function () {
    var _procesAllResults = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(sqInfo) {
      var completePromises, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, qResult;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(sqInfo.hitResults.length > 0)) {
                _context4.next = 23;
                break;
              }

              completePromises = [];
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context4.prev = 5;

              for (_iterator4 = sqInfo.hitResults[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                qResult = _step4.value;
                completePromises.push(qResult.complete());
              }

              _context4.next = 13;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](5);
              _didIteratorError4 = true;
              _iteratorError4 = _context4.t0;

            case 13:
              _context4.prev = 13;
              _context4.prev = 14;

              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }

            case 16:
              _context4.prev = 16;

              if (!_didIteratorError4) {
                _context4.next = 19;
                break;
              }

              throw _iteratorError4;

            case 19:
              return _context4.finish(16);

            case 20:
              return _context4.finish(13);

            case 21:
              _context4.next = 23;
              return Promise.all(completePromises);

            case 23:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[5, 9, 13, 21], [14,, 16, 20]]);
    }));

    function procesAllResults(_x5) {
      return _procesAllResults.apply(this, arguments);
    }

    return procesAllResults;
  }(),
  groupAndFilterResults: function groupAndFilterResults(queryResult) {
    var results = queryResult.getResults();
    var types = [];
    var allResults = [];
    var currentType = null;
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = results[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var result = _step5.value;
        var distance = parseInt(result.distance);

        if (this.distanceFilter === 'all' || distance === 0 && this.distanceFilter === 'zero' || distance > 0 && this.distanceFilter === 'nonzero') {
          result.distance = distance;

          if (currentType === null || result.type !== currentType.type) {
            currentType = {
              type: result.type,
              results: []
            };
            if (result.hasOwnProperty("image") && result.image !== null && result.image !== "") currentType.image = result.image;else currentType.image = this.defaultTargetImage;
            types.push(currentType);
          }

          currentType.results.push(result);
          allResults.push(result);
        }
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    return {
      types: types,
      allResults: allResults
    };
  },
  buildOutput: function buildOutput(typesWithResults) {
    var items = [];

    if (typesWithResults.length === 0) {
      if (this.noResultsListItem !== null) items = items.push(this.noResultsListItem);
    } else {
      if (this.headerListItem !== null) items = items.push(this.headerListItem);
      var doIndent = typesWithResults.length > 1;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = typesWithResults[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var typeWithResults = _step6.value;
          items = items.concat(this.buildTypeItems(typeWithResults, doIndent));
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      if (this.footerListItem !== null) items = items.push(this.footerListItem);
    }

    return items;
  },
  buildTypeItems: function buildTypeItems(typeWithResults, doIndent) {
    var items = [];
    if (doIndent) items = [{
      type: "listheader",
      icon: typeWithResults.image,
      title: typeWithResults.type
    }];
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = typeWithResults.results[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var result = _step7.value;
        items.push({
          type: "result",
          result: result,
          islistitem: doIndent
        });
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    return items;
  },
  CLASS_NAME: 'Septima.Search.SqDetailsHandler'
});